module.exports = __webpack_public_path__ + "img/IMG-20200308-WA0220.953524c8.jpg";